import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  width: 100%;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 56px auto;
  }
`;

export const VideoWrapper = styled.div`
  margin: auto;
  width: 290px;
  height: auto;
  padding: 40px 0 24px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 628px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 841px;
  }
`;

export const VideoDescription = styled.div`
  p {
    color: ${themeGet('colors.main-text')};
    font-size: 18px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    p {
      font-size: 16px;
    }
  }
`;

export const Title = styled.div`
  text-align: center;
`;

export const BottomContent = styled.div``;

export const TranscriptWrapper = styled.div`
  width: 315px;
  text-align: center;
  margin: auto;
  border-top: 1px solid ${themeGet('colors.border-grey')};
  border-bottom: 1px solid ${themeGet('colors.border-grey')};
  padding: 24px;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 628px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 1168px;
  }
`;

export const TranscriptButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  color: ${themeGet('colors.pc-red')};
  display: flex;
  align-items: center;
  line-height: 24px;
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.normal')};
  margin: auto;
  position: relative;
  padding-right: 20px;

  span {
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    padding-bottom: 5px;
    border-bottom: 1px solid currentColor;
  }

  &::after {
    content: '';
    display: inline-block;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    width: 11px;
    height: 11px;
    transform: rotate(45deg) translate(-50%, -50%);
    position: absolute;
    right: 0;
    top: 50%;
  }

  &.hide {
    &:after {
      content: '';
      transform: rotate(-135deg) translate(-50%, -50%);
      top: 15%;
    }
  }
`;

export const Transcript = styled.div`
  width: 100%;
`;

export const Ulist = styled.ul`
  text-align: left;
  li {
    padding: 14px 0;
  }
`;

export const Olist = styled.ol`
  text-align: left;
  li {
    padding: 14px 0;
  }
`;
